import { css } from "styled-components";

import { theme } from "./theme";

export const antSelectOveride = css`
  .ant-select-dropdown {
    & .ant-select-item {
      &-option-selected {
        background-color: ${theme.colors.primary} !important;
        color: ${theme.text.white} !important;
      }
    }
  }
`;

export const antDatePickerOveride = css`
  .ant-picker {
    &-cell-inner {
      width: 35px;
      height: 35px !important;
      display: flex !important;
      align-items: center;
      justify-content: center;
    }
    &-cell-selected {
      .ant-picker-cell-inner {
        background-color: ${theme.colors.primary} !important;
      }
    }
    &-cell-today {
      .ant-picker-cell-inner:before {
        border: 1px solid ${theme.colors.primary} !important;
      }
    }
  }
`;
